import { render, staticRenderFns } from "./BtnInputFile.vue?vue&type=template&id=7d71c2e6&scoped=true&"
import script from "./BtnInputFile.vue?vue&type=script&lang=js&"
export * from "./BtnInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71c2e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VCol,VFileInput})
